/**
 * How readily OS takes speech as its own in live mode, this browser's
 * (docs/plans/os-voice-conversation.addressee.md, option B step 6, decided 7
 * Oct 2026): "Only when I say OS", "Normal" (the default) or "Everything near
 * me", chosen on Settings › OS's voice. Kept in localStorage like Read
 * replies aloud; a browser that refuses storage keeps Normal.
 *
 * The call sends it in its `start` and a `sensitivity` frame on every change
 * while it is up (`use-assistant-live.ts`).
 */
import { DEFAULT_LIVE_SENSITIVITY, readLiveSensitivity, type LiveSensitivity } from '@alluzo/shared';
import { create } from 'zustand';

const STORAGE_KEY = 'alluzo.live-sensitivity';

const readStored = (): LiveSensitivity => {
  try {
    return readLiveSensitivity(localStorage.getItem(STORAGE_KEY)) ?? DEFAULT_LIVE_SENSITIVITY;
  } catch {
    return DEFAULT_LIVE_SENSITIVITY;
  }
};

type LiveSensitivityState = {
  level: LiveSensitivity;
  setLevel: (level: LiveSensitivity) => void;
};

export const useLiveSensitivityStore = create<LiveSensitivityState>((set) => ({
  level: readStored(),
  setLevel: (level) => {
    try {
      localStorage.setItem(STORAGE_KEY, level);
    } catch {
      // Kept for this page's life only.
    }
    set({ level });
  },
}));
